<template>
  <div class="appointment_suc">
    <div v-if="from === 'voucherApplication'">
      <van-nav-bar title="申请成功" left-arrow @click-left="back" />
      <div class="wrap">
        <svg-icon icon-class="suc" />
        <p>卡券申请提交成功</p>
        <div class="tip">
          <span>温馨提示：</span>
          <p>1.卡券申请审核中，申请结果将微信通知您，您也可在<a style="color: #3B86FF" @click="onRun">[卡券管理-申请记录]</a>中查询详情</p>
        </div>
      </div>
    </div>
    <div v-if="from === 'mealBookForm'">
      <van-nav-bar title="订餐成功" left-arrow @click-left="back" />
      <div class="wrap">
        <svg-icon icon-class="suc" />
        <p>订餐申请提交成功</p>
        <div class="tip">
          <span>温馨提示：</span>
          <p>1.该餐次预定成功，详情可查看<a style="color: #3B86FF" @click="onRun">[申请记录]</a>，若需取消请在当天{{ bookingLimitTime }}前取消，超时锁定不可取消</p>
          <p v-if="payType === 'COUPON_PAY'">2.该餐次支付方式仅支持卡券抵扣，已同步提交卡券申请，详情及审核结果可查看<a style="color: #3B86FF" @click="onLink">[卡券管理-卡券记录]</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success',
  data() {
    return {
      from: this.$route.query.from,
      bookingLimitTime: this.$store.state.bookingLimitTime,
      payType: this.$store.state.payType
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'user' });
    },
    onRun() {
      switch (this.from) {
        case 'voucherApplication':
          this.$router.push({ name: 'vouchers' });
          break;
        case 'mealBookForm':
          this.$router.push({ name: 'mealBook' });
          break;
      }
    },
    onLink() {
      switch (this.from) {
        case 'mealBookForm':
          this.$router.push({ name: 'vouchers' });
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.appointment_suc {
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 0.7rem;
    font-size: 0.14rem;
    color: #333;
    > p {
      font-size: 0.2rem;
    }
    .tip {
      text-align: left;
      margin-top: 0.2rem;
      padding: 0 0.27rem;
      line-height: 0.28rem;
      span {
        color: #f2b230;
        line-height: 0.3rem;
      }
      p {
        color: #888;
      }
    }
  }
}
</style>
